module.exports = __webpack_public_path__ + "media/images/menu_sel_2-1376fcc6c2b829ced0d638583ae912ca.png";